import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { WindowSize } from '@domains';
import {
  AboutResupplyDialogComponent,
  FxFlexDirective,
  FxLayoutAlignDirective,
  FxLayoutDirective,
  FxLayoutGapDirective,
  ResponsiveService,
} from '@rspl-ui';
import { StarRatingModule } from 'angular-star-rating';
import { takeUntil } from 'rxjs';

import { BaseSectionComponent } from '../base-section/base.component';

@Component({
  selector: 'rspl-reviews-split-landing',
  templateUrl: './reviews.component.html',
  styleUrl: './reviews.component.scss',
  imports: [FxLayoutDirective, FxLayoutAlignDirective, FxLayoutGapDirective, FxFlexDirective, StarRatingModule, MatIcon],
})
export class ReviewsSectionComponent extends BaseSectionComponent implements OnInit {
  allReviews = [
    [
      {
        name: 'William',
        stars: 5,
        review: `We couldn't be more pleased with the service we received today from Vasily. We had 16 items to donate spread over 3 floors of our house. Vasily arrived earlier than anticipated, reviewed each item and clearly explained how some items were headed for recycling instead of donation due to their wear. I will certainly contact Resupply again should I have items that could see new life with a needy family.`,
        date: '2024.10.20',
        icon: 'ss3-google',
      },
      {
        name: 'Sue',
        stars: 5,
        review: `The pick up team arrived promptly after we received the expected text...they were courteous, friendly and just plain "nice" ..out items were removed quickly, no issues...<br/>I would recommend them to anyone looking to donate....`,
        date: '2024.10.17',
        icon: 'ss3-google',
      },
      {
        name: 'Jim',
        stars: 5,
        review: `The team was terrific. We had lots of furniture to move out, but they came in, jumped in with a can-do attitude, and gladly corrected a slight misunderstanding of what we wanted done. All with a smile. Great.`,
      },
    ],
    [
      {
        name: 'Marcia',
        stars: 5,
        review: `They looked everything over and gave me the final price upfront. It was pretty much the same as what I had gotten online, increased a tad as I added a piece to it. They were on time within the window I was expecting. Super nice and efficient.`,
        date: '2024.10.17',
        icon: 'ss3-google',
      },
      {
        name: 'Helen ',
        stars: 5,
        review: `Very professional and respectful movers. The movers were very professional and efficient. They worked fast but carefully and were very respectful of our home and family. The lead mover also disassembled a table that was too big to go through a door, which I had not anticipated, and was cheerful about itl Thanks for providing such careful service!`,
        date: '2024.10.17',
        icon: 'ss3-check',
      },
      {
        name: 'Nancy',
        stars: 4,
        review: `Fermentum, consectetur nam magnis viverra suspendisse quam condimentum varius.`,
      },
    ],
  ];

  reviews = this.allReviews;

  constructor(
    public override responsiveService: ResponsiveService,
    private dialog: MatDialog,
  ) {
    super(responsiveService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.responsiveService.size.pipe(takeUntil(this.destroy$)).subscribe((size) => {
      this.reviews = [WindowSize.LG, WindowSize.XL, WindowSize.MD].includes(size) ? this.allReviews : [this.allReviews[0]];
    });
  }

  showVideo() {
    this.dialog.open(AboutResupplyDialogComponent, {
      width: '690px',
      maxWidth: '90vw',
      maxHeight: '80vh',
    });
  }
}
